

export const GET_SYNCHRONIZATIONS_WATCHER = 'app/ControlPanel/Synchronization/GET_SYNCHRONIZATIONS_WATCHER';
export const GET_SYNCHRONIZATIONS_SUCCESS = 'app/ControlPanel/Synchronization/GET_SYNCHRONIZATIONS_SUCCESS';
export const GET_SYNCHRONIZATIONS_FAILED = 'app/ControlPanel/Synchronization/GET_SYNCHRONIZATIONS_FAILED';